/* Cart desktop dropdown clearance; leave tablet and mobile layout unchanged. */
(() => {
  const setup = () => {
    const page = document.querySelector('.banditos-cart-v2');
    const nav = document.querySelector('.section-header-navigation .header__inline-menu');
    if (!page || !nav || page.dataset.menuSpaceReady) return;
    page.dataset.menuSpaceReady = 'true';
    const desktop = window.matchMedia('(min-width: 1281px)');
    let frame = 0, until = 0, shift = 0;
    const update = () => {
      frame = 0;
      let next = 0;
      const container = page.querySelector('.cart-container');
      if (desktop.matches && window.scrollY <= 4 && container && nav.getClientRects().length) {
        const closedTop = page.getBoundingClientRect().top + (parseFloat(getComputedStyle(container).paddingTop) || 0);
        let bottom = 0;
        nav.querySelectorAll('.menu-lv-1 > .menu-dropdown').forEach(drop => {
          const css = getComputedStyle(drop);
          if (css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) > .01)
            bottom = Math.max(bottom, drop.getBoundingClientRect().bottom);
        });
        next = bottom ? Math.max(0, Math.ceil(bottom + 16 - closedTop)) : 0;
      }
      if (next !== shift) {
        shift = next;
        page.style.setProperty('--cart-menu-space', shift + 'px');
      }
      if (performance.now() < until) frame = requestAnimationFrame(update);
    };
    const schedule = () => {
      until = performance.now() + 500;
      if (!frame) frame = requestAnimationFrame(update);
    };
    const events = ['pointerover', 'pointerout', 'focusin', 'focusout', 'click'];
    events.forEach(type => nav.addEventListener(type, schedule));
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    const observer = new MutationObserver(schedule);
    observer.observe(nav, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-expanded'] });
    document.addEventListener('shopify:section:unload', function cleanup(event) {
      if (!event.target.contains(page)) return;
      cancelAnimationFrame(frame);
      observer.disconnect();
      events.forEach(type => nav.removeEventListener(type, schedule));
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      document.removeEventListener('shopify:section:unload', cleanup);
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
